<script lang="ts">
    import type {MessagePhoto} from "./Types";
    import FormattedText from "./FormattedText.svelte";
    import Photo from "./Photo.svelte";

    export let entity: MessagePhoto
    export let isChannel: boolean
    export let telegramMessageId: string
</script>
<FormattedText entity={entity.caption}/>
<Photo entity={entity.photo} {isChannel} {telegramMessageId}/>
